<template>
  <div class="login" :class="{active:activeindex ==1}">
    <img class="logo" src="../../../static/images/logo.png" alt="" />
    <p class="title">溯源体系用户登录</p>
    <p class="titleen">TRACEABILITY SYSTEM USER LOGIN</p>
    <div class="kuang">
      <span>账号</span> 
      <input type="text" @click="active()" placeholder="请输入您的账号" v-model="userPhone" />
    </div>
    <div class="kuang">
      <span>密码</span>
      <input type="password" @click="active()" placeholder="请输入您的密码" v-model="password" />
    </div>
    <div class="btn">
      <router-link to="/login/register">注册账号</router-link>
      <router-link to="/login/findpassword">忘记密码</router-link>
    </div>
    <div class="kuang" @click="sginUp">
      <div class="loginbb">
        <div class="bgmask"></div>
        <p>登录</p>
      </div>
    </div>
    <div class="gohome" @click="$router.push('/')">返回首页</div>
    <!-- <div class="empty"></div> -->
    <div class="help">
      <a href="https://yuan.znstny.cn/upload/caozuoshouce.doc">查看溯源中心操作手册</a>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      userPhone: '',
      password: '',
      activeindex: 0
    };
  },
  created() {
    //判断登陆状态,
    if (window.localStorage.getItem('is_check_login') == 1) {
      //已登录
      this.checkShopStatus();
    }
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })()
    }
  },
  watch: {
    screenHeight (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight)
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {
    active() {
      this.activeindex=1
    },
    checkShopStatus() {
      //判断商家审核状态 进行跳转；
      let url = '/front/Appsto/pstatus';
      this.$request.post(url, {}, res => {
        if (res.status == 1) {
          //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
          if (res.result.status == 1) {
            this.$router.push('/projectList');
          } else {
            this.$router.push('/shopinformation');
          }
        }
      });
    },
    //用户账号密码登录
    sginUp() {
      //验证手机号和密码
      if (!this.userPhone) {
        Toast('请输入手机号!')
        return false;
      }
      if (!this.password) {
        Toast('请输入密码!');
        return false;
      }

      let data = {
        mobile: this.userPhone,
        password: this.password,
        is_app:1
      };
      let url = '/front/Login/frontlog';
      this.$request.post(url, data, res => {
        console.log(res);
        if (res.status == 1) {
          window.localStorage.setItem('is_check_login', 1);
          window.localStorage.setItem('store_id', res.result.store_id);
          window.localStorage.setItem('token', res.result.token);
          this.checkShopStatus();
        }
        Toast(res.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.active{
  background-image: url("../../../static/images/logintracing/logoll.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  height: 16.5rem;
}
.login {
  background-image: url("../../../static/images/logintracing/logoll.png");
  height: 16rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  .logo {
    display: block;
    width: 3rem;
    height: 3.3rem;
    margin: 0 auto;
    padding-top: 1.8rem;
  }
  .title {
    font-size: 0.6rem;
    background-image: -webkit-linear-gradient(bottom,#44dec5,#4ebcfa);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
    font-weight: bold;
    margin-top: 0.75rem;
  }
  .titleen{
    text-align: center;
    color: #e6fdff;
    margin-bottom: 1.3rem;
  }
  .btn {
    width: 5rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    a {
      color: #ffffff;
    }
  }
}
.empty{
  height: 0.3rem;
}
/*按钮 输入框*/
.kuang {
  display: flex;
  align-items: center;
  border: 1px solid #06c6df;
  border-radius: 5px;
  color: #ffffff;
  span{
    margin-left: 0.2rem;
  }
  input {
    width: 3.5rem;
    height: 0.75rem;
    line-height: 0.75rem;
    margin-left: 0.2rem;
    opacity: 1;
  }
  .loginbb{
    background-image: url("../../../static/images/search/searchbtn.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    .bgmask {
      width: 100%;
      height: 100%;
      opacity: 0.2;
    }
  }
}
.gohome{
    width: 5rem;
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0rem auto 0.6rem;
    border-radius: 5px;
    overflow: hidden;
    text-align: center;
    background:#eeeeee;
    color: #103069;
    border: #20d6d9 2px solid;
}
.help {
  text-align: center;
  margin-top: 0.3rem;
  width: 5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  margin: 0rem auto 0.6rem;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  background: #cf6006;

  a {
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue